import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {TOAGameEvent} from "../../events/TOAGameEvent";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TombOfAkhenatenGameConfig} from "../../TombOfAkhenatenGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";

export class WaysUpdateView extends BaseView {
    private _stonePresser: ScalableLayer;
    private _waysContainer: PIXI.Container;
    private _spine: PIXI.spine.Spine;
    private _prevRowCount: number = 3;

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, TOAGameEvent.UPDATE_STONE_WAYS, (event: GameEvent) => this.onUpdateWays(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.ON_RESTORE, (event: GameEvent) => this.onRestore(event.params[0]));
    }

    protected initAnimations(): void {
        this._stonePresser = StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.STONE_PRESSER.name);

        this._spine = new PIXI.spine.Spine(GameResources.getSpineAsset("waysUpdateSpine"));
        this.setSpineConfig("243");

        this._waysContainer = new PIXI.Container();
        this._waysContainer.name = "waysSpineContainer";
        this._waysContainer.position.set(56, 40);
        this._waysContainer.addChild(this._spine);

        this._stonePresser.addChild(this._waysContainer);
    }

    private setSpineConfig(skinName: string): void {
        this._spine.skeleton.setSkin(null);
        this._spine.skeleton.setSkinByName(skinName);
        this._spine.skeleton.setSlotsToSetupPose();
        this._spine.state.setAnimation(0, "animation", false);
    }

    private onRestore(rowCount: number): void {
        this.onUpdateWays(rowCount);
    }

    private onUpdateWays(rowCount: number): void {
        if (this._prevRowCount === rowCount) {
            return;
        }
        let level: string = "243";
        switch (rowCount) {
            case 4:
                level = "1024";
                break;
            case 5:
                level = "3125";
                break;
        }
        this._prevRowCount = rowCount;
        this.setSpineConfig(level);
    }
}